import { AnswerSetResult } from "../../../../store/viewmodels/AnswerSetViewModel";
import { Student } from "../../../../store/viewmodels/StudentViewModel";
import { Task } from "../../../../store/viewmodels/TaskViewModel";
import { getDurationInSeconds, getMins, getSeconds } from "../../../utils/DateServices";
import AnswerSetResults from "./AnswerSetResults";

interface TaskResultSummaryProps {
    currentTask: Task,
    answerSets?: AnswerSetResult[]
    student: Student,
    runningNumber: number
}

function TaskResultSummary(props: TaskResultSummaryProps): JSX.Element {
    if (props.answerSets === undefined) {
        return <div key={"empty_" + props.currentTask.id}></div>;
    }

    let tasksAnswerSets = [];
    let allItemsets = props.currentTask.itemsets;
    let activeItemsets = props.student.active_item_sets.map(itemset => itemset.name);
    let doneItemsets: String[] = [];

    for (let a: number = 0; a < props.answerSets.length; a++) {
        let answerset = props.answerSets[a];
        for (let i: number = 0; i < props.currentTask.itemsets.length; i++) {
            let itemset = props.currentTask.itemsets[i];
            if (answerset.itemset.id === itemset.id) {
                let itemsetName = answerset.itemset.name;
                if (!doneItemsets.includes(itemsetName)) {
                    doneItemsets.push(answerset.itemset.name)
                }
                tasksAnswerSets.push(answerset);
            }
        }
    }

    let taskAnswerSetsElements = tasksAnswerSets.map(answerset => (
        <div key={"taskAnswerset_" + answerset.id} className="mt-2">
            <h1 key={"taskAnswerset_h1_" + answerset.id} className="pt-2 pb-2 border-t border-b border-gray-500 text-center text-gray-500 font-bold text-2xl">{answerset.itemset.name}</h1>
            <AnswerSetResults key={"tasksAnswerSetResult_" + answerset.id} answerSet={answerset} student={props.student} />
        </div>
    ));

    let itemsetElements: JSX.Element[] = [];
    for (let i = 0; i < allItemsets.length; i++) {
        const isActive = activeItemsets.includes(allItemsets[i].name);
        const isDone = doneItemsets.includes(allItemsets[i].name) ? true : false;
        let doneColor = "";

        if (!isActive && !isDone) {
            doneColor = "text-gray-500";
        } else if (isDone) {
            doneColor = "text-green-500";
        } else {
            doneColor = "text-red-500";
        }

        itemsetElements.push(
            <div key={"itemsetElement_" + allItemsets[i].id} className="grid grid-cols-4 ml-10">
                <div key={"itemsetElement_firsCol_" + allItemsets[i].id} className="col-span-2">
                    <span key={"itemsetElement_itemsetName" + allItemsets[i].id} className={isDone ? "text-md ri-star-fill text-teal-500" : "text-md text-teal-500 ri-star-line"}></span>
                    {allItemsets[i].name}
                </div>
                <div key={"itemsetElement_isActive" + allItemsets[i].id} className={isActive ? "text-green-500" : "text-gray-500"}>
                    {isActive ? "Aktiivinen" : "Ei-aktiivinen"}
                </div>
                <div key={"itemsetElement_isDone" + allItemsets[i].id} className={doneColor}>
                    {isDone ? "Tehty" : "Tekemättä"}
                </div>
            </div>
        )
    }

    const duration = getTaskDuration(tasksAnswerSets);
    const taskHeader = <h2 className="mt-3 text-4xl font-bold text-gray-900 text-center" key={""}>{props.currentTask.name}</h2>;
    const taskSummary = (
        <div className="text-xl my-4">
            <div>
                <div className="mb-2">
                    <span className="mr-2">
                        {"Kokonaisaika"}
                    </span>
                    <span>
                        {duration}
                    </span>
                </div>
                <div>
                    Teeman tehtäväkokonaisuudet:
                    {itemsetElements}
                </div>
            </div>
        </div>
    );

    let bgColor = "";
    if (props.runningNumber === 0 || props.runningNumber % 2 === 0) {
        bgColor = "bg-teal-50";
    } else {
        bgColor = "bg-white";
    }

    return (
        <div key={"taskResultSummary_" + props.currentTask.id} className={"m-2 border-4 border-gray-400 p-2 " + bgColor}>
            {taskHeader}
            {taskSummary}
            {taskAnswerSetsElements}
        </div>
    );
}

function getTaskDuration(answersets: AnswerSetResult[]): String {
    let allSeconds = 0;

    for (let i: number = 0; i < answersets.length; i++) {
        let answerset = answersets[i];

        const endDate = new Date(Date.parse(answerset.end_time));
        const startDate = new Date(Date.parse(answerset.start_time));
        const durationSeconds = getDurationInSeconds(endDate, startDate);

        allSeconds = allSeconds + durationSeconds;

    }

    const mins: number = getMins(allSeconds);
    const secs: number = getSeconds(allSeconds);

    return mins + " min " + secs + " s";
}

export default TaskResultSummary;